import {
   DESCONSIDERAR_ATIVIDADE,
   EDITAR_ATIVIDADE,
   INCLUIR_ATIVIDADE,
   OBTER_ATIVIDADES,
   OBTER_ATIVIDADES_DETALHES,
   OBTER_ATIVIDADES_TIPO,
   OBTER_ATIVIDADE_POR_ID,
   OBTER_ESCALA,
   OBTER_FUNCIONARIOS,
   OBTER_FUNCIONARIOS_FILTRO,
   OBTER_PATIO,
   OBTER_REFERENCIAS
} from './mutations-types'

export default {
   [OBTER_FUNCIONARIOS](state, payload) {
      if (payload) {
         state.items = payload.items
         state.paginaAtual = payload.paginaAtual
         state.totalDePaginas = payload.totalDePaginas
         state.registrosPorPagina = payload.registrosPorPagina
         state.totalDeRegistros = payload.totalDeRegistros
         state.possuiPaginaAnterior = payload.possuiPaginaAnterior
         state.possuiProximaPagina = payload.possuiProximaPagina
         state.codigo = payload.codigo
         state.sucesso = payload.sucesso
         state.mensagens = payload.mensagens
      } else {
         state.items = null
      }
   },
   [OBTER_FUNCIONARIOS_FILTRO](state, payload) {
      state.funcionarioFiltros = payload
   },
   [OBTER_REFERENCIAS](state, payload) {
      if (payload) {
         state.itemsRef = payload.items
         state.paginaAtualRef = payload.paginaAtual
         state.totalDePaginasRef = payload.totalDePaginas
         state.registrosPorPaginaRef = payload.registrosPorPagina
         state.totalDeRegistrosRef = payload.totalDeRegistros
         state.possuiPaginaAnteriorRef = payload.possuiPaginaAnterior
         state.possuiProximaPaginaRef = payload.possuiProximaPagina
         state.codigoRef = payload.codigo
         state.sucessoRef = payload.sucesso
         state.mensagensRef = payload.mensagens
      } else {
         state.itemsRef = null
      }
   },
   [OBTER_ATIVIDADES](state, payload) {
      if (payload) {
         state.itemsAtv = payload.items
         state.paginaAtualAtv = payload.paginaAtual
         state.totalDePaginasAtv = payload.totalDePaginas
         state.registrosPorPaginaAtv = payload.registrosPorPagina
         state.totalDeRegistrosAtv = payload.totalDeRegistros
         state.possuiPaginaAnteriorAtv = payload.possuiPaginaAnterior
         state.possuiProximaPaginaAtv = payload.possuiProximaPagina
         state.codigoAtv = payload.codigo
         state.sucessoAtv = payload.sucesso
         state.mensagensAtv = payload.mensagens
      } else {
         state.itemsAtv = null
      }
   },
   [OBTER_ATIVIDADES_DETALHES](state, payload) {
      if (payload) {
         state.itemsAtvDtl = payload.items
         state.paginaAtualAtvDtl = payload.paginaAtual
         state.totalDePaginasAtvDtl = payload.totalDePaginas
         state.registrosPorPaginaAtvDtl = payload.registrosPorPagina
         state.totalDeRegistrosAtvDtl = payload.totalDeRegistros
         state.possuiPaginaAnteriorAtvDtl = payload.possuiPaginaAnterior
         state.possuiProximaPaginaAtvDtl = payload.possuiProximaPagina
         state.codigoAtvDtl = payload.codigo
         state.sucessoAtvDtl = payload.sucesso
         state.mensagensAtvDtl = payload.mensagens
      } else {
         state.itemsAtvDtl = null
      }
   },
   [OBTER_ATIVIDADES_TIPO](state, payload) {
      if (payload) {
         state.atividadeTipo = payload.items
         state.paginaAtualTipo = payload.paginaAtual
         state.totalDePaginasTipo = payload.totalDePaginas
         state.registrosPorPaginaTipo = payload.registrosPorPagina
         state.totalDeRegistrosTipo = payload.totalDeRegistros
         state.possuiPaginaAnteriorTipo = payload.possuiPaginaAnterior
         state.possuiProximaPaginaTipo = payload.possuiProximaPagina
         state.codigoTipo = payload.codigo
         state.sucessoTipo = payload.sucesso
         state.mensagensTipo = payload.mensagens
      } else {
         state.itemsTipo = null
      }
   },
   [OBTER_PATIO](state, payload) {
      state.patio = payload.items
   },
   [OBTER_ESCALA](state, payload) {
      state.escala = payload
   },
   [OBTER_ATIVIDADE_POR_ID](state, payload) {
      state.atividadePorId = payload
   },
   [INCLUIR_ATIVIDADE](state, payload) {
      state.incluirAtividade = payload
   },
   [EDITAR_ATIVIDADE](state, payload) {
      state.editarAtividade = payload
   },
   [DESCONSIDERAR_ATIVIDADE](state, payload) {
      state.desconsiderarAtividade = payload
   }
}
